module.exports = __webpack_public_path__ + "assets/473bcff1b4d4d4b444382825b373ff94.mp3";